export default {
  'Teklif Formu': 'Modulo di Preventivo',
  'Kayıtlı Teklifler': 'Preventivi Salvati',
  'Kullanıcı Adı': 'Nome Utente',
  'Şifre': 'Password',
  'Giriş Yap': 'Accedi',
  'Çıkış Yap': 'Esci',
  'KDV Oranı': 'Aliquota IVA',
  'Teklif Durumu': 'Stato Preventivo',
  'Kaydet': 'Salva',
  'PDF Önizleme': 'Anteprima PDF',
  'PDF\'ye Aktar': 'Esporta in PDF',
  'E-posta ile Gönder': 'Invia via Email',
  'Alıcı': 'Destinatario',
  'Tarih': 'Data',
  'Genel Toplam': 'Totale Generale',
  'Not': 'Nota',
  'KDV': 'IVA',
  'Alt Toplam': 'Subtotale',
  'Açıklama': 'Descrizione',
  'Ürün Adı': 'Nome Prodotto',
  'SUT Kodu': 'Codice SUT',
  'Birim Alış Fiyatı': 'Prezzo Unitario',
  'Sipariş Adedi': 'Quantità Ordine',
  'Promosyon Ürün': 'Prodotto Promozionale',
  'Toplam Adet': 'Quantità Totale',
  'Sipariş Tutarı': 'Totale Ordine',
  'Durum': 'Stato',
  'Kabul Edildi': 'Accettato',
  'Reddedildi': 'Rifiutato',
  'Gönderildi': 'Inviato',
  'Taslak': 'Bozza',
  'Yurtiçi': 'Nazionale',
  'Yurtdışı': 'Internazionale',
  'Sipariş Oluştur': 'Crea Ordine',
  'Ürün Sıralaması': 'Ordinamento Prodotti',
  'Ürünler popülerlik ve önem düzeyine göre sıralanmıştır': 'I prodotti sono ordinati per popolarità e importanza',
  'Kardiyoloji ve damar cerrahisi ürünleri öncelikli olarak gösterilmektedir': 'I prodotti di cardiologia e chirurgia vascolare sono mostrati come priorità',
  'Ürün adı, açıklama veya barkod ile ara...': 'Cerca per nome prodotto, descrizione o codice a barre...',
  'Tüm Kategoriler': 'Tutte le Categorie',
  'Kutu görünüm': 'Vista griglia',
  'Liste görünüm': 'Vista lista',
  'Aradığınız kriterlere uygun ürün bulunamadı': 'Nessun prodotto trovato che corrisponda ai tuoi criteri',
  'Ürün Adı Yok': 'Nessun Nome Prodotto',
  'Kategori Yok': 'Nessuna Categoria',
  'Açıklama yok': 'Nessuna descrizione',
  'Firma Bilgilerini Doldurun': 'Compila Informazioni Azienda',
  'Sepete Ekle': 'Aggiungi al Carrello',
  'Firma Bilgileri': 'Informazioni Azienda',
  'Ülke Seçimi': 'Selezione Paese',
  'Türkiye': 'Turchia',
  'Almanya': 'Germania',
  'ABD': 'Stati Uniti',
  'Firma Ünvanı': 'Nome Azienda',
  'Vergi Dairesi': 'Ufficio delle Imposte',
  'Vergi Numarası': 'Numero di Tassa',
  'Adres': 'Indirizzo',
  'Şehir': 'Città',
  'Şehir Seçimi': 'Selezione Città',
  'Şehir Seçiniz': 'Seleziona Città',
  'Şehir adı ara...': 'Cerca nome città...',
  'Aradığınız şehir bulunamadı': 'Città non trovata',
  'Bu ülke için şehir verisi bulunamadı': 'Nessun dato città disponibile per questo paese',
  'şehir bulundu': '{{count}} città trovate',
  'Yetkili': 'Persona Autorizzata',
  'Telefon': 'Telefono',
  'Email': 'Email',
  'Bilgileri İlet': 'Invia Informazioni',
  'Lütfen eksik alanları doldurun': 'Si prega di compilare i campi mancanti',
  'Firma kaydedilemedi': 'L\'azienda non è stata salvata',
  'Firma bilgileri başarıyla iletildi': 'Informazioni azienda inviate con successo',
  'Firma Ünvanı:': 'Nome Azienda:',
  'Yetkili Kişi:': 'Persona Autorizzata:',
  'Sepetiniz': 'Il Tuo Carrello',
  'Sepetiniz boş': 'Il tuo carrello è vuoto',
  'adet': 'pz',
  'Düzenle': 'Modifica',
  'Kaldır': 'Rimuovi',
  'Siparişi Tamamla': 'Completa Ordine',
  'Lütfen önce firma bilgilerinizi eksiksiz iletin': 'Si prega di inviare prima le informazioni complete dell\'azienda',
  'Sipariş başarıyla kaydedildi': 'Ordine salvato con successo',
  'Email adresinize hoş geldiniz mesajı ve erişim linki gönderildi': 'Messaggio di benvenuto e link di accesso inviati alla tua email',
  'Link 3 gün geçerlidir': 'Il link è valido per 3 giorni',
  'Sipariş kaydedilemedi': 'L\'ordine non è stato salvato',
  'Firma Bilgileri Gerekli': 'Informazioni Azienda Richieste',
  'Sepete eklemek için önce firma bilgilerinizi doldurun': 'Compila prima le informazioni dell\'azienda per aggiungere al carrello',
  'Önce Bilgileri Doldurun': 'Compila Prima le Informazioni',
  'Uyarı': 'Avviso',
  'Sepete eklemek için önce firma bilgilerinizi doldurmanız gerekmektedir': 'Devi compilare prima le informazioni dell\'azienda per aggiungere al carrello',
  'SUT Kütüphanesi Tanımı': 'Definizione Biblioteca SUT',
  'SUT Kodu:': 'Codice SUT:',
  'Standart': 'Standard',
  'Açıklama (isteğe bağlı)': 'Descrizione (opzionale)',
  'Partner Ol': 'Diventa Partner',
  'Partner başvuru popup açılacak': 'Si aprirà il popup di candidatura partner',
  'Dil': 'Lingua',
  'E-posta': 'Email',
  'E-Posta': 'Email',
  'Şifre': 'Password',
  'Şifremi Unuttum': 'Password Dimenticata',
  'Giriş yapılıyor...': 'Accesso in corso...',
  'E-posta veya şifre hatalı': 'Email o password non corretti',
  'Şifre sıfırlama e-postası gönderildi': 'Email di reset password inviata',
  'E-posta gönderilemedi': 'L\'email non è stata inviata',
  'Üye Ol': 'Registrati',
  'Üye Değil Misiniz?': 'Non sei membro?',
  'Şimdi Üye Ol': 'Registrati Ora',
  'Misafir Kullanıcı': 'Utente Ospite',
  'Hızlı Sipariş': 'Ordine Rapido',
  'Misafir Olarak Sipariş Verin': 'Ordina come Ospite',
  'Giriş yapmadan hızlıca ürünlerinizi seçin ve siparişinizi oluşturun': 'Seleziona rapidamente i tuoi prodotti e crea il tuo ordine senza accedere',
  'Giriş yapmadan sipariş oluşturun': 'Crea ordine senza accedere',
  'Anında Erişim': 'Accesso Istantaneo',
  'Tüm ürünlere anında erişim': 'Accesso istantaneo a tutti i prodotti',
  'Güvenli İşlem': 'Transazione Sicura',
  'SSL korumalı güvenli sipariş': 'Ordine sicuro protetto da SSL',
  'Misafir Olarak Sipariş Oluştur': 'Crea Ordine come Ospite',
  'İpucu:': 'Suggerimento:',
  'Daha fazla özellik için üye olun': 'Registrati per più funzionalità',
  'Ücretsiz': 'Gratuito',
  'Hızlı': 'Veloce',
  'Güvenli': 'Sicuro',
  'bayilikSozlesme': 'Ho letto e accetto i termini e condizioni di partnership INVAMED.',
  'geri': 'Indietro',
  'basvuruGonder': 'Invia Candidatura',
  'ileri': 'Avanti',
  'sozlesmeGonderildi': 'Contratto Inviato alla Tua Email!',
  'sozlesmeDesc': 'Si prega di caricare il Contratto di Partnership INVAMED e i documenti richiesti inviati alla tua email qui sotto.',
  'tamamla': 'Completa Candidatura',
  'basvuruAlindi': 'La Tua Candidatura è Stata Ricevuta!',
  'basvuruAlindiDesc': 'Il team INVAMED esaminerà la tua candidatura e ti contatterà il prima possibile.',
  'Başvuru Durumu': 'Stato della candidatura',
  'Başvurunuz onay sürecindedir': 'La tua candidatura è in fase di revisione',
  'sifreSifirla': 'Reset Password',
  'sifreSifirlaDesc': 'Inserisci la tua email registrata e ti invieremo le istruzioni per resettare la password.',
  'gonder': 'Invia',
  'talimatGonderildi': 'Istruzioni Inviate',
  'sentDesc': 'Le istruzioni per il reset della password sono state inviate a <b>{email}</b>. Si prega di controllare la tua email.',
  'helpTitle': 'Come posso accedere?',
  'helpList': [
    'Per accedere al pannello distributore INVAMED, inserisci la tua email registrata e password.',
    'Per accedere con l\'utente demo:',
    'Se hai dimenticato la password, usa il link "Password Dimenticata" per richiedere un reset.',
    'Se hai problemi di accesso, assicurati che la tua email e password siano corrette. Se il problema persiste, contatta il nostro team di supporto.'
  ],
  'partnerlikSozlesmeTitle': 'Accordo di Partnership INVAMED e Condizioni',
  'partnerlikSozlesmeText': `1. DISPOSIZIONI GENERALI

Questo accordo è stipulato tra INVAMED (di seguito denominata "Società") e il candidato partner (di seguito denominato "Partner") ai fini della cooperazione nella vendita di dispositivi medici e attrezzature.

2. CONDIZIONI DI PARTNERSHIP

2.1. Il Partner deve avere l'autorità legale per la vendita di dispositivi medici.
2.2. Il Partner deve essere un'organizzazione operante nel settore sanitario.
2.3. Il Partner deve avere le licenze e certificati necessari.
2.4. Il Partner deve essere finanziariamente affidabile.

3. OBBLIGAZIONI DELLE PARTI

Obbligazioni della Società:
3.1. Fornire prodotti e servizi di qualità
3.2. Fornire supporto tecnico
3.3. Fornire formazione e informazioni
3.4. Essere trasparenti sui prezzi

Obbligazioni del Partner:
3.1. Conservare i prodotti in condizioni appropriate
3.2. Fornire servizio clienti di qualità
3.3. Rispettare le normative legali
3.4. Proteggere il marchio aziendale

4. FISSAZIONE PREZZI E PAGAMENTO

4.1. I prezzi sono determinati dalla Società
4.2. Il Partner è tenuto a mantenere i prezzi determinati
4.3. I termini di pagamento sono determinati separatamente
4.4. Le commissioni possono variare in base alle prestazioni

5. RISERVATEZZA E SICUREZZA

5.1. Le parti sono tenute a proteggere le informazioni riservate di ciascuna
5.2. Le informazioni clienti devono essere mantenute riservate
5.3. Gli standard di sicurezza dei dati devono essere rispettati

6. DURATA E RISOLUZIONE DELL'ACCORDO

6.1. Questo accordo è valido per 1 anno
6.2. Può essere esteso per accordo reciproco
6.3. Può essere risolto con preavviso di 30 giorni
6.4. Può essere risolto immediatamente in caso di violazione grave

7. RISOLUZIONE DELLE CONTROVERSIE

7.1. Le controversie sono principalmente tentate di essere risolte attraverso negoziazione
7.2. I tribunali della Repubblica di Turchia sono autorizzati per i casi non risolti

8. EFFICACIA

Questo accordo è stato letto, compreso e accettato dalle parti.`,
  'partnerlikSozlesmeOnay': 'Ho letto, compreso e accetto l\'Accordo di Partnership INVAMED e le Condizioni sopra. Dichiaro di accettare tutti gli articoli di questo accordo e adempirò ai miei obblighi.',
  'sozlesmeyiGoruntule': 'Visualizza Accordo',
  'sozlesmeyiKapat': 'Chiudi',
  'Ürün': 'Prodotto',
  'Ürün eklemek için ürün listesinden seçim yapın': 'Seleziona prodotti dalla lista per aggiungere al carrello',
  'Etiketler': 'Etichette',
  'Öncelikli': 'Priorità',
  'Kapat': 'Chiudi',
  'globalPartnersTitle': 'Collaborazione con 30,000 Partner in Tutto il Mondo',
  'globalPartnersDesc': 'La nostra vasta rete globale di 30,000 partner stimola l\'innovazione condivisa, lo scambio di conoscenze e il successo reciproco. Lavorando insieme, espandiamo continuamente i confini della cura del paziente.',
  'Yardım': 'Aiuto',
  'dil': 'Lingua',
  'Connect Free!': 'Connetti gratis!',
  'En çok tercih edilen ürünlerimizi keşfedin': 'Scopri i nostri prodotti più popolari',
  'Tüm Kategoriler': 'Tutte le categorie',
  '48 ürün gösteriliyor (Toplam: 8000+)': '48 prodotti visualizzati (Totale: 8000+)',
  'Tüm Ürünleri Gör →': 'Vedi tutti i prodotti →',
  'Detaylar': 'Dettagli',
  'Sipariş Ver': 'Ordina ora',
  'Giriş Yap': 'Accedi',
  'Hesabınıza giriş yapın': 'Accedi al tuo account',
  'This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.': 'Questo sito è protetto da reCAPTCHA e si applicano la Politica sulla privacy e i Termini di servizio di Google.',
  'Ürün Kataloğumuz': 'Il nostro catalogo prodotti',
  '8000+ ürün çeşitliliği ile hizmetinizdeyiz': 'Offriamo oltre 8000 prodotti',
  '1,3B': '1,3K',
  'Partner': 'Partner',
  '8,4M': '8,4M',
  'Toplam Üretim': 'Produzione totale',
  '23': '23',
  'Branş': 'Ramo',
  '27,5B': '27,5K',
  'Toplam Sipariş': 'Ordini totali',
  'Connect Now': 'Connetti ora',
  'Tüm bilgilere tek bir yerden erişebilmek için ücretsiz kaydolun.': 'Registrati gratuitamente per accedere a tutte le informazioni in un unico posto.',
  'Ürün Detayları': 'Dettagli prodotto',
  'Kapat': 'Chiudi',
  'Yükleniyor...': 'Caricamento...',
  'Hata': 'Errore',
  '{{count}} ürün gösteriliyor (Toplam: 8000+)': '{{count}} prodotti visualizzati (Totale: 8000+)',
  'Şehir Seçimi': 'Selezione Città',
  'Firma / Sağlık Profesyoneli': 'Azienda / Professionista Sanitario',
  'Yetkili Kişi': 'Persona Autorizzata',
  'Telefon': 'Telefono',
  'E-posta': 'Email',
  'Temel Bilgiler': 'Informazioni di Base',
  'Ek Bilgiler': 'Informazioni Aggiuntive',
  'Faaliyet Alanı / Sektör': 'Area di Attività / Settore',
  'Ülke Seçimi': 'Selezione Paese',
  'Ülke adı veya kodu ara...': 'Cerca nome o codice paese...',
  'region.Avrupa': 'Europa',
  'region.Amerika': 'America',
  'region.Asya': 'Asia',
  'region.Afrika': 'Africa',
  'region.Okyanusya': 'Oceania',
  'region.Diğer': 'Altro',
  'country.TR': 'Turchia',
  'country.US': 'Stati Uniti',
  'country.DE': 'Germania',
  'country.FR': 'Francia',
  'country.GB': 'Regno Unito',
  'country.IT': 'Italia',
  'country.ES': 'Spagna',
  'country.RU': 'Russia',
  'country.CN': 'Cina',
  'country.JP': 'Giappone',
  'country.KR': 'Corea del Sud',
  'country.IN': 'India',
  'country.BR': 'Brasile',
  'country.CA': 'Canada',
  'country.AU': 'Australia',
  'Ticaret Sicil No': 'Numero di Registro Commerciale',

  'country.TR': 'Turchia',
  'country.AL': 'Albania',
  'country.DE': 'Germania',
  'country.AD': 'Andorra',
  'country.AT': 'Austria',
  'country.BY': 'Bielorussia',
  'country.BE': 'Belgio',
  'country.BA': 'Bosnia ed Erzegovina',
  'country.BG': 'Bulgaria',
  'country.CZ': 'Repubblica Ceca',
  'country.DK': 'Danimarca',
  'country.EE': 'Estonia',
  'country.FO': 'Isole Fær Øer',
  'country.FI': 'Finlandia',
  'country.FR': 'Francia',
  'country.GI': 'Gibilterra',
  'country.GR': 'Grecia',
  'country.GG': 'Guernsey',
  'country.HR': 'Croazia',
  'country.NL': 'Paesi Bassi',
  'country.IE': 'Irlanda',
  'country.ES': 'Spagna',
  'country.SE': 'Svezia',
  'country.CH': 'Svizzera',
  'country.IT': 'Italia',
  'country.IS': 'Islanda',
  'country.JE': 'Jersey',
  'country.ME': 'Montenegro',
  'country.LV': 'Lettonia',
  'country.LI': 'Liechtenstein',
  'country.LT': 'Lituania',
  'country.LU': 'Lussemburgo',
  'country.HU': 'Ungheria',
  'country.MT': 'Malta',
  'country.IM': 'Isola di Man',
  'country.MD': 'Moldavia',
  'country.MC': 'Monaco',
  'country.MK': 'Macedonia del Nord',
  'country.NO': 'Norvegia',
  'country.PL': 'Polonia',
  'country.PT': 'Portogallo',
  'country.RO': 'Romania',
  'country.RU': 'Russia',
  'country.SM': 'San Marino',
  'country.RS': 'Serbia',
  'country.SK': 'Slovacchia',
  'country.SI': 'Slovenia',
  'country.SJ': 'Svalbard e Jan Mayen',
  'country.UA': 'Ucraina',
  'country.GB': 'Regno Unito',
  'country.VA': 'Città del Vaticano',
  'country.AX': 'Isole Åland',
  'country.US': 'Stati Uniti',
  'country.AS': 'Samoa Americane',
  'country.AI': 'Anguilla',
  'country.AG': 'Antigua e Barbuda',
  'country.AR': 'Argentina',
  'country.AW': 'Aruba',
  'country.BS': 'Bahamas',
  'country.BB': 'Barbados',
  'country.BZ': 'Belize',
  'country.BM': 'Bermuda',
  'country.BO': 'Bolivia',
  'country.BR': 'Brasile',
  'country.VG': 'Isole Vergini Britanniche',
  'country.CA': 'Canada',
  'country.KY': 'Isole Cayman',
  'country.CL': 'Cile',
  'country.CO': 'Colombia',
  'country.CR': 'Costa Rica',
  'country.CU': 'Cuba',
  'country.CW': 'Curaçao',
  'country.DM': 'Dominica',
  'country.DO': 'Repubblica Dominicana',
  'country.EC': 'Ecuador',
  'country.SV': 'El Salvador',
  'country.FK': 'Isole Falkland',
  'country.GF': 'Guyana Francese',
  'country.GD': 'Grenada',
  'country.GL': 'Groenlandia',
  'country.GP': 'Guadalupa',
  'country.GT': 'Guatemala',
  'country.GY': 'Guyana',
  'country.HT': 'Haiti',
  'country.HN': 'Honduras',
  'country.JM': 'Giamaica',
  'country.MQ': 'Martinica',
  'country.MX': 'Messico',
  'country.MS': 'Montserrat',
  'country.NI': 'Nicaragua',
  'country.PA': 'Panama',
  'country.PY': 'Paraguay',
  'country.PE': 'Perù',
  'country.PR': 'Porto Rico',
  'country.BL': 'Saint-Barthélemy',
  'country.KN': 'Saint Kitts e Nevis',
  'country.LC': 'Saint Lucia',
  'country.MF': 'Saint-Martin',
  'country.PM': 'Saint-Pierre e Miquelon',
  'country.VC': 'Saint Vincent e Grenadine',
  'country.SX': 'Sint Maarten',
  'country.SR': 'Suriname',
  'country.TT': 'Trinidad e Tobago',
  'country.TC': 'Isole Turks e Caicos',
  'country.UY': 'Uruguay',
  'country.VE': 'Venezuela',
  'country.VI': 'Isole Vergini Americane',
  'country.AF': 'Afghanistan',
  'country.AZ': 'Azerbaigian',
  'country.BH': 'Bahrain',
  'country.BD': 'Bangladesh',
  'country.AE': 'Emirati Arabi Uniti',
  'country.BN': 'Brunei',
  'country.BT': 'Bhutan',
  'country.CN': 'Cina',
  'country.TL': 'Timor Est',
  'country.ID': 'Indonesia',
  'country.AM': 'Armenia',
  'country.PH': 'Filippine',
  'country.PS': 'Palestina',
  'country.GE': 'Georgia',
  'country.KR': 'Corea del Sud',
  'country.IN': 'India',
  'country.HK': 'Hong Kong',
  'country.IQ': 'Iraq',
  'country.IR': 'Iran',
  'country.IL': 'Israele',
  'country.JP': 'Giappone',
  'country.KH': 'Cambogia',
  'country.QA': 'Catar',
  'country.KZ': 'Kazakistan',
  'country.KG': 'Kirghizistan',
  'country.CY': 'Cipro',
  'country.KW': 'Kuwait',
  'country.KP': 'Corea del Nord',
  'country.LA': 'Laos',
  'country.LB': 'Libano',
  'country.MO': 'Macao',
  'country.MV': 'Maldive',
  'country.MY': 'Malesia',
  'country.MM': 'Myanmar',
  'country.MN': 'Mongolia',
  'country.NP': 'Nepal',
  'country.UZ': 'Uzbekistan',
  'country.PK': 'Pakistan',
  'country.SG': 'Singapore',
  'country.LK': 'Sri Lanka',
  'country.SY': 'Siria',
  'country.SA': 'Arabia Saudita',
  'country.TJ': 'Tagikistan',
  'country.TH': 'Thailandia',
  'country.TW': 'Taiwan',
  'country.TM': 'Turkmenistan',
  'country.OM': 'Oman',
  'country.JO': 'Giordania',
  'country.VN': 'Vietnam',
  'country.YE': 'Yemen',
  'country.DZ': 'Algeria',
  'country.AO': 'Angola',
  'country.BJ': 'Benin',
  'country.BW': 'Botswana',
  'country.BF': 'Burkina Faso',
  'country.BI': 'Burundi',
  'country.CV': 'Capo Verde',
  'country.CM': 'Camerun',
  'country.CF': 'Repubblica Centrafricana',
  'country.TD': 'Ciad',
  'country.KM': 'Comore',
  'country.CG': 'Repubblica del Congo',
  'country.CD': 'Repubblica Democratica del Congo',
  'country.CI': 'Costa d Avorio',
  'country.DJ': 'Gibuti',
  'country.EG': 'Egitto',
  'country.GQ': 'Guinea Equatoriale',
  'country.ER': 'Eritrea',
  'country.SZ': 'Eswatini',
  'country.ET': 'Etiopia',
  'country.GA': 'Gabon',
  'country.GM': 'Gambia',
  'country.GH': 'Ghana',
  'country.GN': 'Guinea',
  'country.GW': 'Guinea-Bissau',
  'country.KE': 'Kenia',
  'country.LS': 'Lesoto',
  'country.LR': 'Liberia',
  'country.LY': 'Libia',
  'country.MG': 'Madagascar',
  'country.MW': 'Malawi',
  'country.ML': 'Mali',
  'country.MR': 'Mauritania',
  'country.MU': 'Mauritius',
  'country.YT': 'Mayotte',
  'country.MA': 'Marocco',
  'country.MZ': 'Mozambico',
  'country.NA': 'Namibia',
  'country.NE': 'Niger',
  'country.NG': 'Nigeria',
  'country.RE': 'Riunione',
  'country.RW': 'Ruanda',
  'country.SH': 'Sant Elena',
  'country.ST': 'São Tomé e Príncipe',
  'country.SN': 'Senegal',
  'country.SC': 'Seychelles',
  'country.SL': 'Sierra Leone',
  'country.SO': 'Somalia',
  'country.ZA': 'Sudafrica',
  'country.SS': 'Sudan del Sud',
  'country.SD': 'Sudan',
  'country.TZ': 'Tanzania',
  'country.TG': 'Togo',
  'country.TN': 'Tunisia',
  'country.UG': 'Uganda',
  'country.EH': 'Sahara Occidentale',
  'country.ZM': 'Zambia',
  'country.ZW': 'Zimbabwe',
  'country.AU': 'Australia',
  'country.CX': 'Isola di Natale',
  'country.CC': 'Isole Cocos',
  'country.CK': 'Isole Cook',
  'country.FJ': 'Figi',
  'country.PF': 'Polinesia Francese',
  'country.GU': 'Guam',
  'country.HM': 'Isole Heard e McDonald',
  'country.KI': 'Kiribati',
  'country.MH': 'Isole Marshall',
  'country.FM': 'Micronesia',
  'country.NR': 'Nauru',
  'country.NC': 'Nuova Caledonia',
  'country.NZ': 'Nuova Zelanda',
  'country.NU': 'Niue',
  'country.NF': 'Isola Norfolk',
  'country.MP': 'Isole Marianne Settentrionali',
  'country.PW': 'Palau',
  'country.PG': 'Papua Nuova Guinea',
  'country.PN': 'Isole Pitcairn',
  'country.WS': 'Samoa',
  'country.SB': 'Isole Salomone',
  'country.TK': 'Tokelau',
  'country.TO': 'Tonga',
  'country.TV': 'Tuvalu',
  'country.VU': 'Vanuatu',
  'country.WF': 'Wallis e Futuna',
  'country.AQ': 'Antartide',
  'country.BV': 'Isola Bouvet',
  'country.IO': 'Territorio Britannico dell Oceano Indiano',
  'country.TF': 'Terre Australi Francesi',
  'country.GS': 'Georgia del Sud e Isole Sandwich Australi',
};
